var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.982 18.7249C17.2831 17.7999 16.3791 17.0498 15.3411 16.5335C14.303 16.0173 13.1593 15.7491 12 15.7499C10.8407 15.7491 9.69695 16.0173 8.65891 16.5335C7.62087 17.0498 6.71684 17.7999 6.01799 18.7249M17.982 18.7249C19.3455 17.5121 20.3081 15.9135 20.7422 14.141C21.1762 12.3686 21.0613 10.506 20.4125 8.80043C19.7637 7.09482 18.6117 5.62673 17.1094 4.59085C15.6071 3.55497 13.8253 3.00024 12.0005 3.00024C10.1757 3.00024 8.39392 3.55497 6.89159 4.59085C5.38926 5.62673 4.23732 7.09482 3.58852 8.80043C2.93973 10.506 2.82474 12.3686 3.25881 14.141C3.69288 15.9135 4.65449 17.5121 6.01799 18.7249M17.982 18.7249C16.3358 20.1928 14.2055 21.0027 12 20.9999C9.79409 21.003 7.66442 20.193 6.01799 18.7249M15 9.74995C15 10.5456 14.6839 11.3087 14.1213 11.8713C13.5587 12.4339 12.7956 12.7499 12 12.7499C11.2043 12.7499 10.4413 12.4339 9.87867 11.8713C9.31606 11.3087 8.99999 10.5456 8.99999 9.74995C8.99999 8.9543 9.31606 8.19124 9.87867 7.62863C10.4413 7.06602 11.2043 6.74995 12 6.74995C12.7956 6.74995 13.5587 7.06602 14.1213 7.62863C14.6839 8.19124 15 8.9543 15 9.74995Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.dca9040be7c8ea117bae0a2736e6db23.svg";
export { ForwardRef as ReactComponent };